module.exports = __webpack_public_path__ + "static/img/img_ptyw1.1b59cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_ptyw1.png
// module id = zI/5
// module chunks = 19